import { appConfig } from '@/config/appConfig.js'

export class AppConfigPlugin {
  static install(Vue, _options) {
    Vue.prototype.$appConfig = Vue.observable(appConfig)
  }
}
